import $axios from "../api/accessor";
import { $api } from "../api/api";

export const ContactsService = {
  async getAllContacts() {
    let response = await $axios.get($api("contacts")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async deleteContact(id: string | number) {
    const response = await $axios.delete($api("contacts_id", { id }));
    return response.data;
  },
};
